import styled from "styled-components";

import { v } from "constants/css";

export const ModalHeader = styled.div`
  font-size: ${v.xLargeFontSize};
  text-align: center;
`;
